var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.dayOfWeek)+" "+_vm._s(_vm.date)+" "+_vm._s(_vm.clock)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }